import { AxiosResponse } from 'axios'
import { api } from '../../api'

export const balanceWithdrawal = async (eventId: string) => {
  const { status }: AxiosResponse = await api.post(
    `/api/backoffice/events/${eventId}/balance/withdrawal`
  )

  return status
}
